import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { update, fetch } from '../../../Api/definitionCourseEnterprise';

/**
 * Carga el catálogo de cursos y guarda cuáles son obligatorios para toda la
 * empresa.
 *
 * Cada curso viaja como objeto `{ id, name, duration, categoryName, isChecked }`;
 * `isChecked` es lo que ya estaba marcado cuando se abrió la pantalla.
 *
 * @param {Function} setIsLoading - Apaga el indicador de carga de la tabla.
 */
const useCourse = setIsLoading => {
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let isMounted = true;

    fetch().then(({ coursesByEnterprises }) => {
      if (!isMounted) return;

      setCourses(coursesByEnterprises);
      setCategories([...new Set(coursesByEnterprises.map(course => course.categoryName))]);
      setDefaultSelectedIds(coursesByEnterprises.filter(course => course.isChecked).map(course => course.id));
      setIsLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  /**
   * Guarda la diferencia y vuelve al hub, que anuncia el éxito.
   *
   * @param {{id: string, value: boolean}[]} courseData - Cursos a marcar o desmarcar.
   */
  const saveCourses = courseData => {
    update(courseData)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    categories,
    saveCourses,
    defaultSelectedIds,
  };
};

export default useCourse;
